import React from "react";

export default class Hours extends React.Component {
  render() {
    return <div>This is hours view</div>;
  }
}
